import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <div className='reserved-section' >
        @ 2024 Dileepa Malshan. All Rights Reserved
      </div>
      <div className='contact-details'>
        <br />
        Email: dlpmalshan@gmail.com <br />
        Contact No: +94 77 361 3102

      </div>
    </div>
  )
}

export default Footer
